/**
 * Resolve how many recipes a curated pack contains for display and CTAs.
 * Prefers the local preview list, then API recipe_ids / n.
 */
export function packRecipeCount(pack) {
  if (!pack) return 0
  if (Array.isArray(pack.recipes) && pack.recipes.length > 0) {
    return pack.recipes.length
  }
  if (Array.isArray(pack.recipe_ids) && pack.recipe_ids.length > 0) {
    return pack.recipe_ids.length
  }
  if (typeof pack.n === 'number' && pack.n > 0) {
    return pack.n
  }
  return 0
}

export function formatRecipeCount(count) {
  const n = Math.max(0, Number(count) || 0)
  return `${n} recipe${n === 1 ? '' : 's'}`
}

export function packRecipeCountRange(packs = []) {
  const counts = (packs || []).map(packRecipeCount).filter((n) => n > 0)
  if (counts.length === 0) return { min: 0, max: 0, allSame: true }
  const min = Math.min(...counts)
  const max = Math.max(...counts)
  return { min, max, allSame: min === max }
}

function formatRecipeCountSpan({ min, max, allSame }) {
  if (min <= 0) return '0'
  return allSame ? String(min) : `${min}–${max}`
}

/** "4 packs · 5 recipes each" or "8 packs · 5–6 recipes each" */
export function formatPacksEachMeta(packCount, packs) {
  const range = packRecipeCountRange(packs)
  const recipePart = range.allSame
    ? `${range.min} recipes each`
    : `${range.min}–${range.max} recipes each`
  return `${packCount} packs · ${recipePart}`
}

/** "5 recipes per pack — …" with optional suffix */
export function formatRecipesPerPackLine(packs, suffix = '') {
  const range = packRecipeCountRange(packs)
  const countPart = formatRecipeCountSpan(range)
  const base = `${countPart} recipe${range.allSame && range.min === 1 ? '' : 's'} per pack`
  return suffix ? `${base} ${suffix}` : base
}

/** "A pack adds 5 more" / "A pack adds 5–6 more" */
export function formatPackAddsMorePhrase(packs) {
  const range = packRecipeCountRange(packs)
  const countPart = formatRecipeCountSpan(range)
  return `A pack adds ${countPart} more`
}
